import { Button, Layout, Menu, Tooltip } from "antd";
import { useCallback, useMemo, useState } from "react";
import { ROUTES } from "../../../constant/routes";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LogoutOutlined,
  MessageOutlined,
  PictureOutlined,
  UserOutlined,
} from "@ant-design/icons";
import LogoImage from "../../../assets/images/logo.png";
import httpClient from "../../../api/httpClient";
import { parseError } from "../../../utils/shared";
const SideBar = () => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const items = useMemo(
    () => [
      {
        key: ROUTES.CHATS,
        icon: <MessageOutlined />,
        label: "Chats",
      },
      {
        key: ROUTES.PROFILE,
        icon: <UserOutlined />,
        label: "Profile",
      },
      {
        key: ROUTES.POSTER,
        icon: <PictureOutlined />,
        label: "Poster",
      },
    ],
    [],
  );

  const onLogout = useCallback(async () => {
    try {
      setSubmitting(true);

      await httpClient.post("logout", {
        refresh_token: httpClient.getRefreshToken(),
      });
    } catch (error) {
      parseError(error, true);
    } finally {
      localStorage.clear();
      window.location.href = ROUTES.SIGNIN;
      setSubmitting(false);
    }
  }, []);

  return (
    <Layout.Sider className="side-bar" collapsed width={10}>
      <div className="flex justify-center header">
        <img src={LogoImage} className="logo-image" />
      </div>
      <Menu
        theme="light"
        selectedKeys={[location.pathname]}
        onClick={(item) => navigate(item.key)}
        items={items}
      />
      <div className="logout-div">
        <Tooltip title="Sign out" placement="right">
          <Button
            icon={<LogoutOutlined />}
            style={{ width: "100%" }}
            danger
            type="primary"
            onClick={onLogout}
            disabled={submitting}
            loading={submitting}
          />
        </Tooltip>
      </div>
    </Layout.Sider>
  );
};

export default SideBar;
